import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_2 = { style: {"margin-left":"10px"} }

import { onMounted, reactive, ref } from 'vue';
import { HistoryTableTypes, HistoryTypes } from '@/types/HistoryTypes';
import { Calendar } from '@element-plus/icons-vue';
import { dateConvert, dateSort, emailConvert } from '@/helpers/utils';
import { getHistoryRequests, updateHistoryRequests } from '@/api/historyRequests';


export default /*#__PURE__*/_defineComponent({
  __name: 'MailingListArchive',
  setup(__props) {


const loading = ref(true);
const dialogVisible = ref(false);

const tableState = reactive<HistoryTypes>({
  tableData: [],
  tableDataPaged: [],
  selectedRowData: {},
  page: 1,
  pageSize: 10,
});

const currentTableData = (data: HistoryTableTypes[]) => data.slice(
  tableState.pageSize * tableState.page - tableState.pageSize,
  tableState.pageSize * tableState.page,
);

onMounted(async () => {
  const data = await getHistoryRequests();

  const dataSortByDate = data.sort((a, b) => dateSort(b.date, a.date));

  if (data) {
    tableState.tableData = dataSortByDate;
    tableState.tableDataPaged = currentTableData(tableState.tableData);
    loading.value = false;
  }
});

const setPage = (value: number) => {
  tableState.page = value;
  tableState.tableDataPaged = currentTableData(tableState.tableData);
};

const handleEdit = (data: HistoryTableTypes) => {
  tableState.selectedRowData = { ...data };
  dialogVisible.value = true;
};

const handleBeforeClose = () => {
  tableState.selectedRowData = {};
  dialogVisible.value = false;
};

const submitForm = async () => {
  dialogVisible.value = false;
  const { name, company, id } = tableState.selectedRowData;
  const payload = { name, company };
  const data = await updateHistoryRequests(payload, id);
  if (data) {
    const dataUpdate = tableState.tableData.map(((item: { id: string; }) => (item.id === id ? {
      ...item,
      ...tableState.selectedRowData,
    } : item)));

    tableState.tableDataPaged = dataUpdate;
    tableState.tableData = dataUpdate;
  }
};


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: tableState.tableDataPaged,
      border: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "date",
          label: "Date"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Calendar))
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(dateConvert)(scope.row.date)), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "Name"
        }),
        _createVNode(_component_el_table_column, {
          prop: "company",
          label: "Company"
        }),
        _createVNode(_component_el_table_column, {
          prop: "recipients",
          label: "Mail"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_unref(emailConvert)(scope.row.recipients)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "files",
          label: "Files"
        }, {
          default: _withCtx((scope) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.files, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, [
                _createVNode(_component_el_link, {
                  href: item.url,
                  target: "_blank",
                  type: "primary",
                  underline: false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.fileName), 1)
                  ]),
                  _: 2
                }, 1032, ["href"])
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "Operations",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "small",
              onClick: ($event: any) => (handleEdit(scope.row))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Edit")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      onCurrentChange: setPage,
      layout: "prev, pager, next",
      total: tableState.tableData.length
    }, null, 8, ["total"]),
    _createVNode(_component_el_dialog, {
      class: "edit-history",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
      title: "Edit history item",
      "before-close": handleBeforeClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: tableState.selectedRowData,
          "label-position": 'top'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Name",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: tableState.selectedRowData.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tableState.selectedRowData.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Company",
              prop: "company"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: tableState.selectedRowData.company,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tableState.selectedRowData.company) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: submitForm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Confirm ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogVisible.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancel")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})